import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Salesperson } from './interfaces/salesperson.interface';
import { SalespersonApiService } from './salesperson.api.service';

@Injectable()
/**
 * @deprecated Use SalespersonService from sales: https://github.com/vendasta/sales/blob/master/sdks/typescript/src/sales_sdk/src/lib/salesperson/salesperson.service.ts
 */
export class SalespersonService {
  constructor(private salespersonApiService: SalespersonApiService) {}

  /**
   * @deprecated Use SalespersonService from sales: https://github.com/vendasta/sales/blob/master/sdks/typescript/src/sales_sdk/src/lib/salesperson/salesperson.service.ts
   */
  lookup(partnerId: string, marketIds?: string[], includeNullMarket?: boolean): Observable<Salesperson[]> {
    return this.salespersonApiService
      .lookup({ partnerId, marketIds, includeNullMarket })
      .pipe(map((response) => this.handleResponse(response)));
  }

  /**
   * @deprecated Use SalespersonService from sales: https://github.com/vendasta/sales/blob/master/sdks/typescript/src/sales_sdk/src/lib/salesperson/salesperson.service.ts
   */
  private handleResponse(data: any): Salesperson[] {
    return data.map((sp: any) => {
      return {
        partnerId: sp.pid,
        marketId: sp.marketId,
        salespersonId: sp.salesPersonId,
        firstName: sp.firstName,
        lastName: sp.lastName,
        fullName: this.getFullName(sp.firstName, sp.lastName),
        email: sp.email,
      };
    });
  }

  private getFullName(firstName: string, lastName: string): string {
    return `${firstName || ''} ${lastName || ''}`.trim();
  }
}
